import { STEP_GROUP, TUTORIAL_BUTTON_TYPE } from "../../types";
import useTutorialMode from "../useTutorialMode";

const useCompanySelectorActions = (
  handleTutorialCompletion: (stepGroup: STEP_GROUP) => Promise<void>,
  setTutorialCompanySelectorClose: (isOpen: boolean) => void,
) => {
  const { stepIndex, setTutorialDetails } = useTutorialMode();

  const companySelectorTutorialTooltipButtonActions = (
    buttonType: TUTORIAL_BUTTON_TYPE,
  ) => {
    if (buttonType === TUTORIAL_BUTTON_TYPE.Previous) {
      if (stepIndex === 1) {
        setTutorialCompanySelectorClose(true); // this state trigers useEffect in CompanySelector.tsx
        setTutorialDetails({
          isTutorialOpen: true,
          stepIndex: 0,
          stepGroup: STEP_GROUP.TutorialCompanySelector,
          isTutorialActive: true,
        });
      }
    } else {
      handleTutorialCompletion(STEP_GROUP.TutorialCompanySelector);
    }
  };

  return { companySelectorTutorialTooltipButtonActions };
};

export default useCompanySelectorActions;
